import { htmlUnescape, XHR_CONTENT_TYPE, XHR_RESULT_TYPE, hashStringSha256 } from "Util/util.js";
import $ from "jquery";

/**
 * @param {FormData} formData
 * @param {Object} properties
 */
function mergePropertiesToFormData(formData, properties) {
    if (formData && properties) {
        for (const prop in properties) {
            if (properties.hasOwnProperty(prop)) {
                formData.append(prop, properties[prop]);
            }
        }
    }
}

export function getXhrMethods({ onInvalidSessionError, showErrorDialog, setUnsavedChanges }) {
    async function sendXhr({ url, data, sync, headers, contentType, resultType, captureXhr, actionLog }) {
        contentType = contentType || XHR_CONTENT_TYPE.JSON;
        resultType = resultType || XHR_RESULT_TYPE.JSON;
        sync = sync || false;
        let dataParam;
        let contentTypeParam;
        if (Array.isArray(actionLog) && actionLog.length > 0) {
            data["_actionLog_"] = actionLog.slice(-20); //max 20 latest actions.
        }
        switch (contentType) {
            case XHR_CONTENT_TYPE.JSON:
                contentTypeParam = "application/json; charset=utf-8";
                dataParam = JSON.stringify(data);
                break;
            case XHR_CONTENT_TYPE.FormData:
                // This must be false, not "multipart/form-data". The browser (jquery) will set that content
                // type on its own and specify the boundary for formData correctly. If we specify
                // "multipart/form-data" here, the boundary won't be set.
                contentTypeParam = false;
                dataParam = new FormData();
                mergePropertiesToFormData(dataParam, data);
                break;

            default:
                throw new Error(`Unrecognized content type ${contentType}`);
        }
        let dataTypeParam;
        switch (resultType) {
            case XHR_RESULT_TYPE.JSON:
                dataTypeParam = "json";
                break;
            case XHR_RESULT_TYPE.TEXT:
                dataTypeParam = "text";
                break;

            default:
                throw new Error(`Unrecognized result type ${resultType}`);
        }
        const xhrOptions = {
            type: "POST",
            async: !sync,
            url: url,
            cache: false,
            global: true,
            processData: false,
            contentType: contentTypeParam,
            dataType: dataTypeParam,
            data: dataParam,
            headers: {}
        };
        if (headers) {
            xhrOptions.headers = headers;
        }
        if (contentType === XHR_CONTENT_TYPE.JSON) {
            headers["pc-digest"] = await hashStringSha256(dataParam);
        }

        let result;
        try {
            const xhr = $.ajax(xhrOptions);
            if (captureXhr) {
                captureXhr(xhr);
            }
            result = await xhr;
        } catch (e) {
            raiseAjaxError(e);
            throw e;
        }
        if (resultType === XHR_RESULT_TYPE.JSON) {
            if (result.status === "success") {
                return result;
            } else {
                await raiseResponseError(result.error, result.title, result.showHtml, {
                    correlationId: result.correlationId,
                    timestamp: result.timestamp
                });
                throw result.error || result.apiError;
            }
        } else if (resultType === XHR_RESULT_TYPE.TEXT) {
            return result;
        }
    }
    function raiseResponseError(responseError, title, showHtml, errorMetadata) {
        if (responseError == "InvalidSession") {
            setUnsavedChanges(false);
            if (onInvalidSessionError) {
                onInvalidSessionError();
            }
        } else {
            console.error("AJAX call failed! Error = " + htmlUnescape(responseError));
            return showErrorDialog(title, responseError, showHtml, false, errorMetadata);
        }
    }

    //TODO fix, the arguments are almost certainly not used properly
    function raiseAjaxError(xhr, status, error) {
        // Silence unauthorized errors so we can silently redirect to the login page
        if (error != "Unauthorized") {
            console.error("AJAX call failed! Status = " + status + ", Error = " + error);
        }
    }
    return {
        sendXhr,
        raiseResponseError
    };
}
